export const PATH = {
  APPLICATION_LIST: 'applications',
  STATUS_COUNTER: 'applications/statusCounters',
  FILTERS: 'applications/filtersData',
  APPLICATION_FOR_SIGN: '/status/forSign',
  APPLICATION_FOR_CALL: '/status/forCall',
  APPLICATION_APPROVE: '/status/approve',
  APPLICATION_REJECT: '/status/reject',
}
